import React, { useContext, useEffect } from "react";
import AppRoutes from "../Routes/Routes";
import { AuthContext } from "../Context/AuthContext";
import NotificationToast from "../Components/Common/NotificationToast/NotificationToast";
import { useLocation, useNavigate } from "react-router-dom";
import { setAuthToken } from "../RestApi/tokenUtils";
import { isObjectEmpty } from "../Utils/utils";

const Layouts = ({ children }) => {
  const { userData, authUser } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (token) {
      setAuthToken(token);
      authUser();
      // Remove query param from URL
      navigate(location.pathname, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <React.Fragment>
      <AppRoutes />
      <NotificationToast
        variant="success"
        position={"bottom-end"}
        toastPosition={"bottom-end"}
        autoHide={true}
        delay={500000}
      />
    </React.Fragment>
  );
};

export default Layouts;
